// Хелпер целей Yandex.Metrika (счётчик 110998082, Соня 29.07).
// Безопасно: если счётчик ещё не загрузился — просто no-op.
const YM_COUNTER = 110998082;

export const ymGoal = (goal: string): void => {
  try {
    (window as any).ym?.(YM_COUNTER, 'reachGoal', goal);
  } catch {
    /* noop */
  }
};
